import { StaticProvider } from '@angular/core';
import { DfPropProjectOnAddEventHandler } from '@iris/common/modules/fields/project-sk-select/on-add-event-handler';
import { NG_SELECT_EVENT_HANDLER } from '@iris/common/modules/fields/sk-select-field/ng-select-event-handler.sk';
import { templateFromComponentProvider } from '@iris/common/modules/fields/sk-select-field/template-provider';
import { SEARCH_ENGINE } from '@iris/common/modules/fields/sk-select-field/search-engine.sk';
import {
  BIND_LABEL,
  BIND_VALUE,
  DROPDOWN_FOOTER_TEMPLATE,
  DROPDOWN_HEADER_TEMPLATE,
  OPTION_TEMPLATE,
  OPTGROUP_TEMPLATE,
  GROUP_BY,
} from '@iris/common/modules/fields/sk-select-field/properties-tokens.sk';
import { IrisProjectSelectDropdownHeaderComponent } from './dropdown-header/dropdown-header.component';
import { IrisProjectSelectDropdownFooterComponent } from './dropdown-footer/dropdown-footer.component';
import { IrisProjectSelectDropdownItemComponent } from './dropdown-item/dropdown-item.component';
import { IrisProjectSelectDropdownGroupItemComponent } from './dropdown-group-item/dropdown-group-item.component';
import { IrisProjectSelectEngine } from './project-select.engine';

export const PROJECT_SELECT_PROVIDERS: StaticProvider[] = [
  {
    provide: IrisProjectSelectEngine,
    useClass: IrisProjectSelectEngine,
  },
  {
    provide: SEARCH_ENGINE,
    useExisting: IrisProjectSelectEngine,
  },
  {
    provide: DROPDOWN_FOOTER_TEMPLATE,
    ...templateFromComponentProvider(IrisProjectSelectDropdownFooterComponent, 'template'),
  },
  {
    provide: OPTION_TEMPLATE,
    ...templateFromComponentProvider(IrisProjectSelectDropdownItemComponent, 'template'),
  },
  {
    provide: OPTGROUP_TEMPLATE,
    ...templateFromComponentProvider(IrisProjectSelectDropdownGroupItemComponent, 'template'),
  },
  {
    provide: DROPDOWN_HEADER_TEMPLATE,
    ...templateFromComponentProvider(IrisProjectSelectDropdownHeaderComponent, 'template'),
  },
  {
    provide: BIND_LABEL,
    useValue: 'name',
  },
  {
    provide: BIND_VALUE,
    useValue: 'id',
  },
  {
    provide: GROUP_BY,
    useValue: 'projects',
  },
  { provide: DfPropProjectOnAddEventHandler, useClass: DfPropProjectOnAddEventHandler },
  { provide: NG_SELECT_EVENT_HANDLER, useExisting: DfPropProjectOnAddEventHandler, multi: true },
];
